import { Button, InputGroup, Form } from 'react-bootstrap';
import C4FInfoButton from './C4FInfoButton';
import React, { useEffect } from "react";
import { useState } from 'react';


function C4FSimpleTextField(props) {

  const [value, setValue] = useState('value' in props ? props.value : '');

  useEffect(() => {
    setValue(props.value)
  }, [props.value]);

  return (
    <InputGroup className={props.className}>
      {'info' in props && props.info !== null ?
        <C4FInfoButton title={'displayName' in props ? props.displayName : props.name} text={props.info} />
        : null
      }
      <InputGroup.Text>{'displayName' in props ? props.displayName : props.name}</InputGroup.Text>
      {'disabled' in props && props.disabled ?
        <Form.Control disabled value={value} />
        :
        <>
          <Form.Control
            type={'type' in props ? props.type : 'text'}
            onChange={(e) => { 
              setValue(!('trimValue' in props) || props.trimValue ? 
                e.target.value.trim() : 
                e.target.value);
              props.updateMethod(props.name, e.target.value); 
            }}
            placeholder={'displayName' in props ? props.displayName : props.name}
            value={value}/>
        </>
      }
      { props.actionMethod ?
          <Button variant={'outline-secondary'} onClick={props.actionMethod} >{props.actionMethodName ? props.actionMethodName : 'define actionMethodName'}</Button>
      : null }
      { props.validationMethod ?
        (props.validationMethod(props.name) ?
          <Button variant={'success'} disabled >{'\u2713'}</Button>
          :
          <Button variant={'warning'} disabled >{'!'}</Button>)
        : null  
      }
      {props.status}
    </InputGroup>
  );
}

export default C4FSimpleTextField;